// Equation 24
function calculateTotalCf4Emissions(
  cf4EmissionFactor: number,
  anodeEffectOvervoltagePerCell: number,
  avgCurrentEfficiency: number,
  activityLevel: number
) {
  return (
    cf4EmissionFactor *
    (anodeEffectOvervoltagePerCell / avgCurrentEfficiency) *
    activityLevel *
    0.001 // Emissions factor is in (kgCF4/tAl/mV), so we need to convert to (kgCF4/tAl)
  )
}

// Equation 25
function calculateTotalC2f6Emissions(totalCf4Emissions: number, c2f6EmissionFactor: number) {
  return totalCf4Emissions * c2f6EmissionFactor
}

// Equation 26
export default function calculatePFCEmissionsUsingOvervoltageMethod(parameters: {
  cf4EmissionFactor: number
  anodeEffectOvervoltagePerCell: number
  avgCurrentEfficiency: number
  c2f6EmissionFactor: number
  activityLevel: number
  gwpcf4: number
  gwpc2f6: number
  collectionEfficiency: number
}): number {
  const {
    cf4EmissionFactor,
    anodeEffectOvervoltagePerCell,
    avgCurrentEfficiency,
    activityLevel,
    c2f6EmissionFactor,
    gwpcf4,
    gwpc2f6,
    collectionEfficiency
  } = parameters

  const cf4EmissionsPerTon = calculateTotalCf4Emissions(
    cf4EmissionFactor,
    anodeEffectOvervoltagePerCell,
    avgCurrentEfficiency,
    activityLevel
  )

  const c2f6EmissionsPerTon = calculateTotalC2f6Emissions(cf4EmissionsPerTon, c2f6EmissionFactor)

  const emission =
    (c2f6EmissionsPerTon * gwpc2f6 + cf4EmissionsPerTon * gwpcf4) / collectionEfficiency

  return emission
}
